const locationsState = {
    locations: undefined,
    requestingLocations: false,
    siteSlugs: undefined
};
export default locationsState;
